var _circle, _circle2, _path, _path2, _path3, _path4, _circle3, _circle4, _circle5, _circle6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSpeaker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 185,
    height: 190,
    viewBox: "0 0 185 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 97.2363,
    r: 92.5,
    fill: "#ECEFF3"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 92.5,
    cy: 97.2363,
    r: 92.5,
    stroke: "#F58120"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65 68.5L120.5 43.5V128L65 105V68.5Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M89.0006 75C86.5932 75 84.5688 76.7254 84.1018 79H81.0139C80.4501 78.992 79.9914 79.4521 80.0001 80.0098C80.0101 80.5674 80.4623 81.0075 81.0139 81H84.1018C84.5688 83.2746 86.5932 85 89.0006 85C91.4079 85 93.4323 83.2746 93.8992 81H106.986C108.338 81.0191 108.338 78.9809 106.986 79H93.8992C93.4323 76.7254 91.4079 75 89.0006 75ZM89.0006 77C90.6693 77 92.0007 78.3313 92.0007 80C92.0007 81.6687 90.6693 83 89.0006 83C87.3318 83 86.0004 81.6687 86.0004 80C86.0004 78.3313 87.3318 77 89.0006 77Z",
    fill: "#528FF5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M99.001 87C96.5937 87 94.5692 88.7254 94.1023 91H81.0139C80.4501 90.992 79.9914 91.4521 80.0001 92.0098C80.0101 92.5674 80.4623 93.0075 81.0139 93H94.1023C94.5692 95.2746 96.5937 97 99.001 97C101.408 97 103.433 95.2746 103.9 93H106.986C108.338 93.0191 108.338 90.9809 106.986 91H103.9C103.433 88.7254 101.408 87 99.001 87ZM99.001 89C100.67 89 102.001 90.3313 102.001 92C102.001 93.6687 100.67 95 99.001 95C97.3322 95 96.0009 93.6687 96.0009 92C96.0009 90.3313 97.3322 89 99.001 89Z",
    fill: "#528FF5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.0522 65.2077H66.5371L119.457 41.3626C121.519 40.277 124.059 41.7532 124.059 44.1377V72.5918C126.244 73.2914 128.202 74.5041 129.789 76.0901L129.802 76.1026C132.378 78.6832 133.973 82.2396 133.973 86.1584C133.973 90.074 132.378 93.6335 129.802 96.2141L129.789 96.2266C128.202 97.8126 126.244 99.0253 124.059 99.7249V128.179C124.026 130.418 121.74 131.982 119.635 131.034L66.5387 107.109H64.7864L70.0919 131.9C70.9641 135.963 68.7302 139.916 64.5401 140.818C59.4526 141.862 54.1628 138.29 53.0741 133.199L47.4893 107.109H44.0522C42.3203 107.109 40.9147 105.703 40.9147 103.972V98.404H32.1375C30.4056 98.404 29 96.9984 29 95.2665V77.0502C29 75.3183 30.4056 73.9127 32.1375 73.9127H40.9147V68.3452C40.9147 66.6133 42.3203 65.2077 44.0522 65.2077ZM40.9147 92.129V80.1877H35.275V92.129H40.9147ZM124.059 79.4598V92.8569C124.532 92.5526 124.97 92.1981 125.365 91.8027L125.378 91.7902C126.81 90.3595 127.698 88.3656 127.698 86.1584C127.698 83.9495 126.81 81.9572 125.378 80.5265L125.365 80.514C124.97 80.1187 124.532 79.7641 124.059 79.4598ZM152.671 106.607C155.587 109.523 151.151 113.96 148.235 111.043L138.511 101.32C135.595 98.404 140.032 93.9676 142.948 96.8839L152.671 106.607ZM142.948 75.4312C140.032 78.3475 135.595 73.9111 138.511 70.9948L148.235 61.2717C151.151 58.3554 155.587 62.7918 152.671 65.7081L142.948 75.4312ZM138.715 89.2959C134.59 89.2959 134.59 83.0208 138.715 83.0208H152.467C156.045 83.0208 157.57 89.2457 152.467 89.2959H138.715ZM58.3796 107.109H53.8961L59.2016 131.9C59.5107 133.348 61.0873 134.724 62.587 134.724C64.6342 134.628 64.0067 133.393 63.6851 131.895L58.3796 107.109ZM70.0182 70.5085V101.808L117.784 123.33V48.9868L70.0182 70.5085ZM63.7432 71.4827H47.1897V77.0502V95.2665V100.834H50.0213H60.9116H63.7432V71.4827Z",
    fill: "#1E334E"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60.0067,
    cy: 40.9658,
    r: 4,
    transform: "rotate(-59.0682 60.0067 40.9658)",
    fill: "#528FF5"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 26.0321,
    cy: 13.0321,
    r: 7.5,
    transform: "rotate(-59.0682 26.0321 13.0321)",
    stroke: "#F58120",
    strokeWidth: 4
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 112.674,
    cy: 166.658,
    r: 4,
    transform: "rotate(-54.2054 112.674 166.658)",
    fill: "#F58120"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 148.647,
    cy: 180.885,
    r: 4,
    transform: "rotate(-54.2054 148.647 180.885)",
    stroke: "#528FF5",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeaker);
export default __webpack_public_path__ + "static/media/speaker.2e67871f62340b4327f991b8ab7aca46.svg";
export { ForwardRef as ReactComponent };